/**
 * inCust terminal API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface TemporaryCode {
  /**
   * Temporary code
   */
  code?: string;
  /**
   * Allowed redeem bonuses or special account flag
   */
  redeem_allowed?: boolean;
}
